<template>
  <div>
    <div class="banner-top" v-if="bannerList.length && bannerList.length > 0">
      <el-carousel trigger="click" height="400px" >
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img class="banner-image" :src="item.imgUrl" @click="bannerClick(index)"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 小白训练营 -->
    <div class="trains">
      <div class="page-continer">
        <div class="header">
          <img src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-title-1.png" />
          <h3 class="title">小白训练营</h3>
        </div>
        <div class="boxs">
          <div class="box" v-for="(item, index) in campList"  v-if="index < 4">
            <img class="bg" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/right-icon-bg.png" />
            <img :src="item.poster"/>
            <div class="title">课程大纲</div>
            <div class="courses" v-html="item.intro"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 精品进阶课 -->
    <div class="good-courses">
      <div class="page-continer">
        <div class="header">
          <img src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-title-2.png" />
          <h3 class="title">精品进阶课</h3>
        </div>
        <div class="boxs">
          <div class="box" v-for="(item, index) in seriesList" v-if="index < 3">
            <img :src="item.poster" />
            <div class="txts">
              <div class="title">{{item.title}}</div>
              <div class="desc">{{item.subtitle}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 课程亮点 -->
    <div class="courses-eyes">
      <div class="page-continer">
        <!-- <img class="pos-img" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-bot-left.png" /> -->
        <div class="header">
          <img class="pic-server" src="../../assets/images/index-title-5.png" />
          <h3 class="title">学习与服务</h3>
        </div>
        <div class="boxs">
          <div class="box">
            <div class="box-bg"></div>
            <div class="box-info">
              <img class="image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-1.png">
              <img class="hover-image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-active-1.png">
              <div class="title">社群学习</div>
              <div class="desc">班主任、助教老师全程陪伴式学习，及时解决您在学习过程中遇到各种问题。同学间相互交流，共同进步！</div>
              <div class="number">01</div>
            </div>
          </div>
          <div class="box">
            <div class="box-bg"></div>
            <div class="box-info">
              <img class="image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-2.png">
              <img class="hover-image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-active-2.png">
              <div class="title">多端学习</div>
              <div class="desc">在看点快课堂小程序、APP、官网上都可以学习，保障教学效果，为每一位学员提供优质服务。</div>
              <div class="number">02</div>
            </div>
          </div>
          <div class="box">
            <div class="box-bg"></div>
            <div class="box-info">
              <img class="image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-3.png">
              <img class="hover-image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-active-4.png">
              <div class="title">一对一服务</div>
              <div class="desc">班主任老师会全程跟踪你的学习效果，尽最大努力帮助你学习进步！</div>
              <div class="number">03</div>
            </div>
          </div>
          <div class="box">
            <div class="box-bg"></div>
            <div class="box-info">
              <img class="image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-4.png">
              <img class="hover-image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-icon-bot-active-3.png">
              <div class="title">干货满满</div>
              <div class="desc">授课老师拥有丰富的理论和实战经验，课程反复打磨，每一节课都能学到实用知识。</div>
              <div class="number">04</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 名师团队 -->
    <div class="teachers-team">
      <div class="header">
        <img src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-title-4.png" />
        <h3 class="title">名师团队</h3>
        <img class="team" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-title-teacher.png" />
      </div>
      <div class="teachers-banners">
        <div class="swiper-container" id="swiper-container" @mouseleave="coverActMouseout">
          <div v-if="teacherIntroShow" @mouseleave="coverActMouseout">
            <div class="banner-active-box" :style="{'left': activeLeft+ 'px'}">
              <img class="cover" :src="teacherList[bannerIndex].photo" />
              <div class="teacher-info">
                <div class="teacher-name">{{teacherList[bannerIndex].name}}</div>
                <p class="intro">{{teacherList[bannerIndex].intro}}</p>
              </div>
            </div>
          </div>
          <div class="swiper-wrapper">
            <div v-for='(item, index) in teacherList' class="swiper-slide">
              <div class="banner-item" @mouseenter="coverMouseover(index)">
                <div class="mask-box">
                  <div class="mask-name">{{item.name}}</div>
                </div>
                <img class="cover" :src="item.photo"   style="height: 354px;" />
              </div>
            </div>
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-prev arraw" ></div>
        <div class="swiper-button-next arraw" ></div>
      </div>
    </div>
    <div class="botoom">
      <img class="bot-image" src="//kandian-1254383113.file.myqcloud.com/cloud/pc/index-title-bottom.png" />
    </div>
  </div>
</template>

<script>
  import { getIndexServer } from '../../server/index';
  import VueMetaInfo from '../../vue-meta-info.js';
  import Swiper from 'swiper' 
  import 'swiper/swiper.scss';

  export default {
    name: 'HelloWorld',
    metaInfo: VueMetaInfo.first,
    data () {
      return {
        activeIndex: 0,
        bannerIndex: 0,
        bannerList: [],
        activeLeft: 134,
        teacherIntroShow: false,
        campList: [],
        seriesList: [],
        teacherList: [],
      }
    },
    async mounted() {
      const _this = this;
      const { code = 1, msg = '', ...res } = await getIndexServer();
      if (code === 0) {
        const { bannerList = [], campList = [], seriesList = [], teacherList = [] } = res.data;
        // bannerList = []
        _this.bannerList = bannerList;
       
        _this.campList = campList;
        _this.seriesList = seriesList;
        _this.teacherList = teacherList;
         await _this.swiperHandler();
      } else {
        _this.$message.error(msg);
      }
    },
    methods: {
      bannerClick(index) {
        console.log('index: ', index);
        let url = this.bannerList[index].exts.href;
        if (url.includes('http://') || url.includes('https://')) {
          window.open(url, '_blank');
        }
      },
      swiperHandler() {
        const _this = this;
        _this.$nextTick(function() {
          // banner
          new Swiper('#banner-swiper', {
            centeredSlides: false,
            autoplay: true,
            loop: false,
            pagination: {
              el: '.banner-swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.banner-swiper-button-next',
              prevEl: '.banner-swiper-button-prev',
              disabledClass: 'my-button-disabled',
        　　},
            on: {
            }
          })
          // 名师团队
          new Swiper('#swiper-container', {
            slidesPerView: 4,
            spaceBetween: 23,
            centeredSlides: false,
            loop: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              disabledClass: 'my-button-disabled',
        　　},
            on: {
              slideChange: function(swiper, a) {
                _this.activeIndex = this.realIndex;
              }
            }
          })
        });
      },
      coverMouseover(index) {
        this.bannerIndex = index;
        if (this.activeIndex !== 0) {
          index = index - this.activeIndex
        }

        if (index % 4 === 0) {
          this.activeLeft = 0;
        } else if (index % 4 === 1) {
          this.activeLeft = 134;
        } else if (index % 4 === 2) {
          this.activeLeft = 400;
        } else if (index % 4 === 3) {
          this.activeLeft = 550;
        }
        
        this.teacherIntroShow = true;
      },
      coverActMouseover() {
        this.teacherIntroShow = true;
      },
      coverActMouseout() {
        this.teacherIntroShow = false;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="./scss/index.scss"></style>
<style lang="scss">
  .banner-top {
    .el-carousel__arrow {
      width: 1200px;
      height: 48px;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: default;
      pointer-events: none;

      border-radius: 0;
      background-color: transparent;
      &:hover {
        background-color: transparent;
      }

      i {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        font-size: 16px;
        text-align: center;
        line-height: 48px;

        pointer-events: auto;
        background-color: rgba(0, 0, 0, .7);

        &.el-icon-arrow-left {
          float: left;
        }

        &.el-icon-arrow-right {
          float: right;
        }
      }
    }

    .el-carousel__indicators {
      .el-carousel__button {
        width: 35px;
        height: 3px;
      }
    }
  } 
    
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue